<template>
    <div>
        <review-list-link :listLayout="listLayout" :reviewData="List" :paginationData="filterSet.page"></review-list-link>
        <pagination-link :paginationLayout="paginationLayout" :paginationData="filterSet.page"></pagination-link>
    </div>
</template>

<script>
    import filterMixins from "@/mixins/filterMixins";
    import listMixins from "@/mixins/listMixins";
    import reviewUtil from "@/components/review/reviewUtil";
    import ReviewListLink from "@/components/review/ReviewListLink";
    import PaginationLink from "@/components/review/PaginationLink";
    import DeleteClass from "@/mixins/deleteClass";
    import alertMixins from "@/mixins/alertMixins";
    import {mapState, mapGetters} from 'vuex';
    import util from "@/mixins/util";
    import EventBus from "@/utils/event-bus";

    const {filterConfig} = reviewUtil;
    export default {
        name: "reviewComponent",
        mixins: [filterMixins, listMixins, reviewUtil, alertMixins],
        components: {
            ReviewListLink,
            PaginationLink,
        },
        inject: ['changeLoading'],
        provide() {
            return {
                setPage: this.setPage,
                setFilter: this.setFilter,
                setReviewData: this.setData,
                reviewDelete: this.runDeleteConfirm,
            }
        },
        props: {
            reviewType:{},
            userKey: {default: 0},
        },
        data() {
            return {
                listLayout: '',
                paginationLayout: '',

                getFunc: '',
                listApiParamSet: {},
                pageRow: 10,

                deleteFunc: '',
                deleteApiParamsSet: {},
                keyName: '',
                deleteSuccessType: 1,
                deleteErrorTypes: {},

                selectedData: {},
            }
        },
        created() {
            this.initConfig();
            this.setFilterConfig(filterConfig)
            this.setParserType('url', this.$route.fullPath);
            this.newDeleteClass();

        },
        mounted() {
            this.getList(true)
        },
        beforeDestroy() {
        },
        computed: {
            ...mapState({
                db: state => state.db,
            })
        },
        methods: {
            setData(key, value){
                this[key] = value;
            },
            initConfig() {
                let reviewConfig = this.returnReviewConfig(this.reviewType);
                this.listLayout = reviewConfig.listLayout;
                this.paginationLayout = reviewConfig.paginationLayout;
                this.getFunc = reviewConfig.getFunc;
                this.listApiParamSet = reviewConfig.listApiParamSet;

                this.deleteFunc = reviewConfig.deleteFunc;
                this.deleteApiParamsSet = reviewConfig.deleteApiParamsSet;
                this.deleteSuccessType = reviewConfig.deleteSuccessType;
                this.deleteErrorTypes = reviewConfig.deleteErrorTypes;
                this.keyName = reviewConfig.keyName;

                if(this.userKey != 0) {
                    this.listApiParamSet.rem = this.userKey;
                }
                let listOptions = {
                    url : this.$api.$review[this.getFunc],
                    defaultParams: this.listApiParamSet,
                }
                this.initList('api', listOptions);


            },
            newDeleteClass() {
                let deleteOptions = {
                    func: this.$api.$review[this.deleteFunc],
                    apiParamSet: this.deleteApiParamsSet,
                    successType: this.deleteSuccessType,
                    errorTypes: this.deleteErrorTypes,
                    keyName: this.keyName,
                    afterFunc: this.deleteAlertFunc,
                };
                this.DeleteClass = new DeleteClass(deleteOptions);
            },
            runDeleteConfirm(reviewData) {
                this.createConfirm({
                    content: '정말 삭제하시겠습니까?',
                    confirm: () => {
                        this.runDelete(reviewData);
                    }
                })
            },
            runDelete(reviewData) {
                this.changeLoading(true);
                this.selectedData = reviewData;
                this.DeleteClass.runDelete(this.selectedData.wr_id);
                // this.deleteAlertFunc(this.selectedData.wr_id);
            },
            deleteAlertFunc(wr_id) {
                this.createAlert({
                    content: '삭제 되었습니다.'
                })
                this.changeLoading(false);

                this.updateTransfer();
                EventBus.$emit('memberDetailGet');
                let reviewIndex = this.List.findIndex(review => review[this.keyName] === wr_id);
                if(reviewIndex > -1) {
                    this.List.splice(reviewIndex, 1);
                    this.setPage('total', this.filterSet.page.total - 1);
                    this.getNewData();
                }
            },
            getNewData() {
                if(this.filterSet.page.total <= this.filterSet.page.page * this.filterSet.page.size) {
                    return false;
                }

                let params = JSON.parse(JSON.stringify(this.listApiParamSet));
                params.page = this.filterSet.page.page * this.pageRow + 1;
                params.sp = 1;
                this.$api.$review[this.getFunc](params).then(res => res.Data.Result).then(res => {
                    if(res.Info.type === 1 && res.List.length > 0) {
                        this.List.push(res.List[0]);
                    }
                })

                return true;
            },
            updateTransfer() {
                let reviewData = this.selectedData;
                let $this = this;
                if(util.isEmpty(this.selectedData.Rate) || util.isEmpty(this.selectedData.Rate.transferId)) {
                    return false;
                }
                let transferId = this.selectedData.Rate.transferId;
                const lngRef = this.db.collection('lngTransfer').doc(transferId);
                lngRef.get().then(doc => {
                    let transfer =  doc.data();
                    transfer.id = transferId;
                    if( transfer ){
                        let users = transfer.users;
                        util.Object.each(users, (key, user, obj) => {
                            if(!util.isEmpty(user.review) && user.review.wr_id == reviewData.wr_id) {
                                user.review = null;
                            }
                        })
                        let updateData = {users: users};
                        lngRef.set(updateData, {merge: true}).then(res => {
                            console.log("Lng Create created: ");
                            $this.selectedData = {};
                        }).catch(function(error) {
                            console.log("Lng Create Err: ", error);
                        });
                    }
                })
                return true;
            },
        },
        watch: {},
    }
</script>

<style scoped>

</style>
